var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isAuthenticated || !_vm.$route.meta.requiresAuth,
          expression: "isAuthenticated || !$route.meta.requiresAuth"
        }
      ],
      staticClass: "app h-100"
    },
    [
      _c(
        "section",
        { attrs: { id: "appView" } },
        [
          _c("router-view", {
            key: _vm.routeKey,
            attrs: { event: _vm.appEvent },
            on: {
              "set-header-title": _vm.setHeaderTitle,
              "set-header-extra": _vm.setHeaderExtra,
              "set-logo-filename": _vm.setLogoFilename
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-center text-white" }, [
        _vm._v("© " + _vm._s(_vm.year) + " Wiland, Inc. All rights reserved.")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }